import { clsx } from "clsx";
import { twMerge } from "@multiplicu/tailwind-config/merge";
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
